import { topicRepositoryImplementation } from '@shared/infrastructure/http/repositories/topic/topicRepositoryImplementation';
import {
  Topic,
  TopicFromRepoModel,
  TopicRepoModel,
  TopicToRepoModel
} from '@shared/domain/topic/topic.aggregate';

export interface TopicRepository {
  getTopics: (countryCode: string, languageCode: string) => Promise<Topic[]>;
  uploadTopicImgBackground: (
    topicId: number,
    countryCode: string,
    body: any
  ) => Promise<string>;
  toggleEnableTopic: (topicId: number, countryCode: string) => Promise<void>;
  updateTopic: (
    countryCode: string,
    languageCode: string,
    data: Topic
  ) => Promise<void>;
  createTopic: (
    countryCode: string,
    languageCode: string,
    data: Topic
  ) => Promise<void>;
  deleteTopic: (countryCode: string, topicId: number) => Promise<void>;
}

export const topicRepository: TopicRepository = {
  getTopics: (countryCode, languageCode) => {
    const topicPromise: Promise<TopicRepoModel[]> =
      topicRepositoryImplementation.getTopics(countryCode, languageCode);

    return topicPromise.then((topics) => {
      return topics.map((topic) => TopicFromRepoModel(topic));
    });
  },
  uploadTopicImgBackground: (
    topicId: number,
    countryCode: string,
    body: any
  ) => {
    return topicRepositoryImplementation.uploadTopicImgBackground(
      topicId,
      countryCode,
      body
    );
  },
  toggleEnableTopic: (topicId: number, countryCode: string) => {
    return topicRepositoryImplementation.toggleEnableTopic(
      topicId,
      countryCode
    );
  },
  updateTopic: (countryCode, languageCode, data) => {
    return topicRepositoryImplementation.updateTopic(
      countryCode,
      languageCode,
      TopicToRepoModel(data)
    );
  },
  createTopic: (countryCode, languageCode, data) => {
    return topicRepositoryImplementation.createTopic(
      countryCode,
      languageCode,
      TopicToRepoModel(data)
    );
  },
  deleteTopic: (countryCode, topicId) => {
    return topicRepositoryImplementation.deleteTopic(countryCode, topicId);
  }
};
